import { firestoreTimestampFilterProps } from "../../../Components/EnhancedTableFilterUtils";
import {
  type FilterTableItemDescriptor,
  generateHeadersAndFilters,
} from "../../../Components/FilterTable/filterTableUtils";
import { type GCPTableUpdate } from "./types";

const itemsDescriptions: FilterTableItemDescriptor<GCPTableUpdate>[] = [
  {
    headerText: "Customer",
    value: "customerName",
    filterType: "string",
  },
  {
    headerText: "Big Query Job ID",
    value: "bqJobId",
    filterType: "string",
  },
  {
    headerText: "Billing Account",
    value: "billingAccount",
    filterType: "string",
  },
  {
    headerText: "Start date",
    value: "fromDate",
    filterType: "string",
  },
  {
    headerText: "End date",
    value: "toDate",
    filterType: "string",
  },
  {
    headerText: "Status",
    value: "status",
    filterType: "string",
  },
  {
    headerText: "Created at",
    value: "createdAt",
    filterOptions: {
      ...firestoreTimestampFilterProps("yyyy-LL-dd"),
    },
  },
  {
    headerText: "Email",
    value: "email",
    filterType: "string",
  },
];

export const { headerColumns, filters } = generateHeadersAndFilters(itemsDescriptions);
